(() => {
  function init(root) {
    if (!root || root.dataset.ready) return;
    const controls = root.querySelector('[data-controls]');
    const search = root.querySelector('[data-search-input]');
    const category = root.querySelector('[data-category]');
    const evidence = root.querySelector('[data-evidence]');
    const topics = Array.from(root.querySelectorAll('[data-topic]'));
    const count = root.querySelector('[data-count]');
    const empty = root.querySelector('[data-empty]');
    const normalize = value => value.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[’']/g, '');
    if (!controls || !search || !category || !evidence || !count || !empty) return;
    root.dataset.ready = 'true';
    const index = new Map(topics.map(topic => [topic, normalize(topic.dataset.search + ' ' + topic.textContent)]));
    function filter() {
      const words = normalize(search.value).trim().split(/\s+/).filter(Boolean);
      let shown = 0, refs = 0;
      topics.forEach(topic => {
        const match = words.every(word => index.get(topic).includes(word)) && (!category.value || topic.dataset.group === category.value) && (!evidence.value || topic.dataset.status === evidence.value);
        topic.hidden = !match;
        if (match) { shown++; refs += Number(topic.dataset.refs); }
      });
      count.textContent = shown + (shown === 1 ? ' topic' : ' topics') + ' · ' + refs + (refs === 1 ? ' reference' : ' references');
      empty.hidden = shown > 0;
    }
    function reset() { search.value = ''; category.value = ''; evidence.value = ''; filter(); }
    search.addEventListener('input', filter);
    category.addEventListener('change', filter);
    evidence.addEventListener('change', filter);
    root.querySelector('[data-reset]').addEventListener('click', () => { reset(); search.focus(); });
    function revealHash() {
      let id;
      try { id = decodeURIComponent(window.location.hash.slice(1)); } catch (_) { return; }
      const target = topics.find(topic => topic.id === id);
      if (!target) return;
      if (target.hidden) reset();
      const details = target.querySelector('details');
      if (details) details.open = true;
      target.scrollIntoView({block: 'start'});
    }
    window.addEventListener('hashchange', revealHash);
    controls.hidden = false;
    root.querySelector('[data-reset]').hidden = false;
    filter(); revealHash();
  }
  init(document.getElementById('rxo2-research'));
  document.addEventListener('shopify:section:load', () => init(document.getElementById('rxo2-research')));
})();
